import styled from 'styled-components'
import { spacing } from 'helpers'

export const Container = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.light};
  position: relative;
  padding: ${spacing(2)};
  padding-bottom: ${spacing(1)};
`
